import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import interact from 'interactjs';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import './index.less';
import ChartTable from './table';
import Chart from './chart';
import { DataChart as DataChartService } from '../../services/mscratch/service/datachart';
import DataChartRedux from '../../reducers/dataChart';
import Emitter from '../../services/emitter';

function dataUrl2Blob(dataUrl) {
    var arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bStr = atob(arr[1]),
        n = bStr.length,
        unit8Array = new Uint8Array(n);
    while (n--) {
        unit8Array[n] = bStr.charCodeAt(n);
    }
    return new Blob([unit8Array], { type: mime });
}

class ChartIndex extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            type: '',
            xAxisName: '',
            yAxisName: '',
            chartName: '',
            xAxisData: [],
            seriesData: []
        };

        this.listeners = {
            setChartName:this.setChartName.bind(this),
            setChartType:this.setChartType.bind(this),
            setAxisName: this.setAxisName.bind(this),
            updateData: this.updateData.bind(this),
            clearChart: this.clearChart.bind(this),
        };

        for (const key in this.listeners) {
            Emitter.on(key, this.listeners[key]);
        }

        this.table = React.createRef();
        this.renderChart = this.renderChart.bind(this);
        this.closeChart = this.closeChart.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.getChildEchart = this.getChildEchart.bind(this);
    }

    componentDidMount() {
        this.registerDrag();
        this.restoreData();
    }

    componentWillUnmount(){
        for (const key in this.listeners) {
            Emitter.removeListener(key, this.listeners[key]);
        }
    }

    //调用echart转成图片功能需要获取子组件的echart
    getChildEchart(echart) {
        this.echart = echart;
    }

    restoreData() {
        const data = DataChartService.getAllData();
        this.setState({
            type: data.chartType,
            xAxisName: data.xAxisName,
            yAxisName: data.yAxisName,
            chartName: data.chartName,
            xAxisData: [...data.xAxisData],
            seriesData: [...data.seriesData]
        });
    }

    handleDownload() {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1 ;
        const day = now.getDate();
        const hour = now.getHours();
        const min = now.getMinutes();
        const timeStr = `${this.state.chartName}${year}${month}${day}${hour}${min}`;
        if (this.state.type === 'table') {
            const elt = ReactDOM.findDOMNode(this.table).getElementsByTagName('table')[0];
            const wb = XLSX.utils.table_to_book(elt, { sheet: 'Sheet JS' });
            return XLSX.writeFile(wb, `${timeStr}.csv`);
        } else {
            const imageDataUrl = this.echart.getDataURL();
            const imageBlobData = dataUrl2Blob(imageDataUrl);
            FileSaver.saveAs(imageBlobData, `${timeStr}.png`);
        }
    }

    closeChart() {
        this.props.closeChart();
    }

    setChartType(type) {
        this.setState({
            type: type
        });
    }

    updateData(xAxisData, seriesData) {
        this.setState({
            xAxisData: [...xAxisData],
            seriesData: [...seriesData]
        });
    }

    setAxisName(xAxisName, yAxisName) {
        this.setState({
            xAxisName,
            yAxisName
        });
    }

    clearChart() {
        this.setState({
            xAxisData: [],
            seriesData: []
        });
    }

    setChartName(data) {
        this.setState({
            chartName: data
        });
    }

    registerDrag() {
        interact('.chart-container').draggable({
            onmove: this.dragMoveListener
        });
    }

    dragMoveListener(event) {
        let target = event.target;
        let x = (parseInt(target.getAttribute('data-x')) || 0) + parseInt(event.dx);
        let y = (parseInt(target.getAttribute('data-y')) || 0) + parseInt(event.dy);
        target.style.webkitTransform =
            target.style.transform =
            'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    renderChart(event) {
        let type = event.currentTarget.getAttribute('datatype');
        //通过service设置type才能让service保存type
        DataChartService.setType(type);
    }

    render() {
        const { messages } = this.props.intlr;

        return (
            <section className="chart-container">
                <div className="chart-header">
                    <h1 className="title">{this.state.chartName}</h1>
                    <i className={`mblock-icon icon-guanbidawurongqi`} onClick={this.closeChart}></i>
                    {/* <img src={closeImg} type="close" onClick={this.closeChart} /> */}

                    {/* <button onClick={this.renderChart.bind(this)} datatype='pi'>饼状图</button> */}
                </div>
                <div className="chart-body">
                    {
                        this.state.type === ''? null :
                            this.state.type === 'table' ?
                                <ChartTable
                                    ref={e => this.table = e}
                                    xAxisName={this.state.xAxisName}
                                    yAxisName={this.state.yAxisName}
                                    xAxisData={this.state.xAxisData}
                                    seriesData={this.state.seriesData}
                                /> :
                                <Chart
                                    getChildEchart={this.getChildEchart}
                                    type={this.state.type}
                                    xAxisName={this.state.xAxisName}
                                    yAxisName={this.state.yAxisName}
                                    xAxisData={this.state.xAxisData}
                                    seriesData={this.state.seriesData}
                                />
                    }
                </div>
                <div className="chart-footer">
                    <div className="chart-button" onClick={this.handleDownload}>
                        <i className="mblock-icon icon-xiazai" ></i>
                        <span className="chart-button-name">{messages['BUTTON.CHART.DOWNLOAD']}</span>
                    </div>
                    <div
                        className={`chart-button ${this.state.type === 'table' ? 'current' : ''}`}
                        onClick={this.renderChart}
                        datatype='table'>
                        <i className="mblock-icon icon-biaoge"></i>
                        <span className="chart-button-name">{messages['BUTTON.CHART.TABLE']}</span>
                    </div>
                    <div
                        className={`chart-button ${this.state.type === 'line' ? 'current' : ''}`}
                        onClick={this.renderChart}
                        datatype='line'
                    >
                        <i className="mblock-icon icon-xiantu" ></i>
                        <span className="chart-button-name">{messages['BUTTON.CHART.LINE']}</span>
                    </div>
                    <div
                        className={`chart-button ${this.state.type === 'bar' ? 'current' : ''}`}
                        onClick={this.renderChart}
                        datatype='bar'>
                        <i className="mblock-icon icon-zhuzhuangtu" onClick={this.renderChart} ></i>
                        <span className="chart-button-name">{messages['BUTTON.CHART.BAR']}</span>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

const mapDispatchToProps = dispatch => ({
    closeChart: () => {dispatch(DataChartRedux.actions.close());}
});

let ChartComponent = connect(mapStateToProps, mapDispatchToProps)(ChartIndex);

export {
    ChartComponent as default
};